import { Article, Footer } from "./Article";

export default function App() {
    return (
        <>
            <div className="sm:py-32 flex flex-row justify-center items-center sm:flex-wrap xl:h-screen lg:h-screen md:h-screen px-24">
                <Article />
            </div>
            <div>
                <Footer />
            </div>
        </>
    );
}
